import type { Task } from "@/sdk";
import { isChatTask, isVoiceTask } from "@/sdk";

/** Safely get the reservation SID from a Twilio task */
export function getReservationSid(task: Task | undefined): string | undefined {
    // For Twilio tasks that have a config property with reservation
    if (isVoiceTask(task) || isChatTask(task)) {
        // Use type assertion because the interface doesn't expose the internal implementation details
        // TODO: Update the SDK to include reservation SID in the Task interface
        const twilioTask = task as Task & { config?: { reservation?: { sid?: string } } };
        return twilioTask.config?.reservation?.sid ?? twilioTask?.analyticsData?.ReservationSid ?? undefined;
    }
    return undefined;
}
